import { render, staticRenderFns } from "./TopFactors.vue?vue&type=template&id=38a5a33b&scoped=true&"
import script from "./TopFactors.vue?vue&type=script&lang=ts&"
export * from "./TopFactors.vue?vue&type=script&lang=ts&"
import style0 from "./TopFactors.vue?vue&type=style&index=0&id=38a5a33b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a5a33b",
  null
  
)

export default component.exports